<template>
    <div class="size-full rounded-lg border flex flex-col items-center p-[12px]">
        <div class="w-full"><h2 class="flex items-center gap-x-2">Regroupement par ancieneté <Info :size="15" strokeWidth="1.3"/></h2></div>
        <div class="grow flex flex-col justify-end items-center">
            <div class="size-[200px]">
                <apexchart type="donut" :options="options" :series="series" width="100%" height="100%"></apexchart>
            </div>
        </div>
    </div>
</template>
<script>
import {Info} from "lucide-vue-next"
export default {
    name: "RangeSeniority",
    components:{
        Info
    },
    props:["datas"],
    data(){
        return {
            series: [],
            options:{
                chart: {
                    width: "auto",
                    type: 'donut',
                    toolbar: {  
                        show: false
                    },
                },
                stroke: {
                    width: 2,
                },
                labels: ['0-4 ans', '5-9 ans', '10-14 ans', '15-19 ans','20-24 ans','25-29 ans','30-34 ans','35-39 ans','40+ ans'],
                // colors: ['#fe713c', '#ee4636','#099556','#5589f6','#55f6c6','#f6ab55'],
                plotOptions:{
                    pie:{
                        expandOnClick: false,
                        donut:{
                            size: '85%',
                            labels:{
                                show: true,
                                total: {
                                    show: true,
                                    label: 'Total',
                                    fontWeight: 100,
                                    fontSize: '14px',
                                    formatter: function(w) {
                                        let total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                                        return total.toFixed(0);
                                    }
                                }
                            }
                        },
                    }
                },
                dataLabels: {
                    enabled: false
                    },
                    legend:{
                        show:false
                },
            }
        }
    },
    mounted(){
        this.series = [
            this.datas["0-4"],
            this.datas["5-9"],
            this.datas["10-14"],
            this.datas["15-19"],
            this.datas["20-24"],
            this.datas["25-29"],
            this.datas["30-34"],
            this.datas["35-39"],
            this.datas["40+"]
        ]
    },
    // methods:{
    //     calculPercent(range_value,sum){
    //         return Math.ceil((range_value/ sum)*100)
    //     }
    // },
}
</script>